<button type="button" class="btn-action btn-left">
  <span class="icon material-symbols-outlined"> chevron_left </span>
</button>
